import React from "react";

const Add = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M56 32H32V56H24V32H0V24H24V0H32V24H56V32Z" fill="black" />
    </svg>
  );
};

export default Add;
